export var PusherConfig = {
    Dispensary: {
        CHANNEL: function(dispensaryId) {
            return "private-curbside-arrivals-user-".concat(dispensaryId);
        },
        Events: {
            CURBSIDE_ARRIVAL_ARRIVED: 'curbside-arrival-arrived',
            CURBSIDE_ARRIVAL_CLEARED_ALL: 'curbside-arrival-cleared-all',
            CURBSIDE_ARRIVAL_CLEARED: 'curbside-arrival-cleared',
            CURBSIDE_ARRIVAL_UPDATED: 'curbside-arrival-updated'
        }
    },
    DispensaryOrders: {
        CHANNEL: function(param) {
            var id = param.id;
            return "dispensary-".concat(id, "-orders");
        },
        Events: {
            ORDER_UPDATED: 'order-updated'
        }
    },
    Order: {
        CHANNEL: function(orderId) {
            return "order-".concat(orderId);
        },
        Events: {
            ORDER_UPDATED: 'order-updated'
        }
    },
    PrivateOrder: {
        CHANNEL: function(orderId) {
            return "private-order-".concat(orderId);
        },
        Events: {
            ORDER_PRINTED: 'client-order-printed'
        }
    },
    PersistentRequests: {
        CHANNEL: function(param) {
            var id = param.id;
            return "persistent-requests-session-".concat(id);
        },
        Events: {
            RESOLVED: 'persistent-request-resolved'
        }
    },
    PublicContextSession: {
        CHANNEL: function(sessionId) {
            return "public-context-session-".concat(sessionId);
        },
        Events: {
            SESSION_UPDATED: 'session-updated',
            LOGIN_METHOD_VERIFIED: 'login-method-verified',
            SESSION_CLAIMED: 'session-claimed',
            SESSION_EXPIRED: 'session-expired'
        }
    },
    Terminal: {
        CHANNEL: function(param) {
            var deviceId = param.deviceId;
            return "private-terminal-".concat(deviceId);
        },
        Events: {
            PRINT: 'print-from-commands'
        }
    },
    Consumer: {
        CHANNEL: 'consumer-general',
        Events: {
            ReloadApp: 'reload-app'
        }
    },
    Admin: {
        CHANNEL: 'admin-general',
        Events: {
            ReloadApp: 'reload-app'
        }
    },
    ContentCleanup: {
        CHANNEL: 'presence-content-cleanup-tool',
        Events: {
            SUBSCRIPTION_ERROR: 'pusher:subscription_error',
            SUBSCRIPTION_SUCCEEDED: 'pusher:subscription_succeeded'
        }
    },
    Buckets: {
        CHANNEL: 'buckets',
        Events: {
            CREATED: 'created',
            DESTROYED: 'destroyed',
            UPDATED: 'updated'
        }
    },
    DeviceConnections: {
        Events: {
            sendConnectionToken: 'SEND_CONNECTION_TOKEN',
            connectionFinalized: 'CONNECTION_FINALIZED'
        }
    },
    InstoreCart: {
        CHANNEL: function(orderId) {
            return "dutchie-instore-cart-".concat(orderId);
        },
        EVENTS: {
            INSTORE_CART_LOADED: 'cart_loaded'
        }
    },
    AeroSyncPreAuth: {
        CHANNEL: function(channelName) {
            return channelName;
        },
        EVENTS: {
            PRE_AUTH_STATUS_CHANGE: 'status_change'
        }
    }
};
